import Smartphones from 'Salaries/views/SalaryAddBenefitView/containers/Smartphones'
import Tablets from 'Salaries/views/SalaryAddBenefitView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const SalaryAddBenefitView = getCurrentDeviceView(Smartphones, Tablets)

export default SalaryAddBenefitView
